import Highcharts from 'highcharts';
Highcharts.setOptions({
	lang: {
		      decimalPoint: ','
	      }

});

export const figure76 = {
chart: {
backgroundColor: 'rgba(255, 255, 255, 0.0)',
type: 'column',
height: 700,
spacingTop: 30



},
title: {
text: ''
},
//exporting: {
//menuItemDefinitions: {


//  },
//buttons: {
//    contextButton: {
//		   menuItems: ['JPG', 'PDF'],
//   symbol: 'url(../img/download-table.svg)'
//   }
//}
//},
credits: {
enabled: false
},
xAxis: {
categories: ['Superficies artificiales', 'Tierras cultivables', 'Praderas', 'Zonas cubiertas de árboles', 'Zonas cubiertas de arbustos', 'Humedales', 'Zonas con escasa vegetación', 'Terreno raso terrestre', 'Nieve permanente y glaciares', 'Masas de aguas continentales'],
opposite: true,
// tickInterval: 5,

// tickmarkPlacement: 'on',
// tickPositions: [0, 5, 10, 15, 19]
labels: {
style: {
textOverflow: 'none'
}
},

},
yAxis: {
title: {
text: 'Variación porcentual de la superficie (%)'
}, labels: {
formatter: function () {
return this.value + '';
}
},
min: -20,
max: 120,
tickInterval: 20,

},
tooltip: {
// pointFormat: 'Series {series.name} <b>{point.y:.4f}</b>'
headerFormat: "<span style='font-size: 10px'>{point.key}</span><br>",
pointFormat: "<span style='color:{point.color}''>\u25CF</span> {series.name}: <b>{point.y}%</b>",
},
legend: {
	       enabled: false,
       }, 
plotOptions: {
column: {
pointPadding: 0,
borderWidth: 0
},
series: {
marker: {
enabled: false,
"symbol": 'circle',
// radius: 2
}
}
},
//colors: ['#77A612', '#66A6B7', '#00122F', 'yellow', 'pink', 'purple', '#77A612', '#66A6B7'],
series: [{
name: 'Basal',
color: '#a5a5a5',
data: [30.23366714, -6.714819574, 0.296415008, 0.134437731, -0.004685851, -0.399746531, 0.248361879, -0.428960785, 0, 0.039904374]
}, {
name: 'Alpino',
color: '#e6ddcc',
data: [22.69262464, -2.043133941, 0.281082113, -1.786896542, 4.119295496, 1.130228348, -0.025143686, -0.41226328, -0.000380385, 2.811552978]

}, {
name: 'Montano',
color: '#a9b6a2',
data: [99.27320862, -1.14250375, 1.029856891, -0.098244399, 2.057382387, -13.17265273, 1.182269207, -4.516383773, 0, 0.864070048]

}, {
name: 'Zona montañosa restante',
color: '#6c8b8d',
data: [106.8999059, -1.434170168, 1.485119449, 0.516605775, -0.266213052, -8.085202734, 0.129679582, -2.725070073, 0, 1.233746493]

}


]
}
